module.exports = __webpack_public_path__ + "img/11233815.66c8e0ac.png";